import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=d787c3b0"
import script from "./PageBreadcrumbs.js?vue&type=script&lang=js&external"
export * from "./PageBreadcrumbs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports